// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InviteStyles .modal-content {
    /* border-radius: 30px; */
    /* width:700px;
    min-height: 593px;
    padding-left: 20px;
    padding-right: 20px; */
    background-color: #fff !important;
}

.background-for-whole {
    border-radius: 30px;
    width: 90%;

    margin: 20px auto;
    padding: 20px;
    min-height: 400px;
    background-color: #fff  !important;
}

.InviteStyles .title {
    font-size: 20px;
    font-weight: 700;
}

.InviteStyles .InvitationEmail {
    /* border:1px solid red; */
    width: 95%;
    margin: auto;
    margin-bottom: 20px;
}

.InviteStyles .InvitationEmail input {
    width: 100%;
    border-radius: 50px;
    border: 2px solid grey;
    font-size: 16px;
    padding: 11px;
}

.InviteStyles .InvitationSubject {
    width: 95%;
    margin: auto;
    margin-bottom: 20px;

}

.InviteStyles .InvitationSubject input {
    width: 100%;
    border-radius: 50px;
    border: 2px solid grey;
    font-size: 16px;
    padding: 11px;
}

.InviteStyles .InvitationTextaera {
    /* border:1px solid red; */
    width: 95%;
    margin: auto;
    margin-bottom: 20px;
    
}

.InviteStyles .InvitationTextaera textarea {
    width: 100%;
    border-radius: 20px;
    border: 2px solid grey;
    font-size: 16px;
    padding: 11px;
}

.InviteStyles .Invite {
    width: 88px;
    height: 33px;
    border: none;
    border-radius: 20px;
    background-color: rgb(7, 55, 100);
    color: white;
    margin-left: 270px;
    cursor: pointer;
}

.InviteStyles .Invite:disabled {
    width: 88px;
    height: 33px;
    border: none;
    border-radius: 20px;
    background-color: #98B9D8;
    color: white;
    margin-left: 270px;
    cursor: pointer;
}

.InviteStyles .Change {
    position: relative;
    padding: 10px;
    text-align: center;
}

.InviteStyles .Change::before {
    content: "";
    position: absolute;
    top: 22px;
    left: 8px;
    border: 1px solid;
    width: 290px;
    height: 2px;
}

.InviteStyles .Change::after {
    content: "";
    position: absolute;
    top: 22px;
    right: 8px;
    border: 1px solid;
    width: 290px;
    height: 2px;
}

.or-container{
    display: flex;
}
.or-container hr{
    flex:1 1
}
.or-container p{
    padding: 8px 16px;
}

/* .InviteStyles .GmailContacts {
    margin-left: 60px;
    width: 250px;
    height: 33px;
    border: none;
    border-radius: 20px;
    background-color: #F3F2F0;
} */

/* .InviteStyles .GmailContacts span {
    color: #3E90E1;
    margin-left: 20px;
} */

/* .InviteStyles .FacebookContacts {
    margin-left: 30px;
    width: 250px;
    height: 33px;
    border: none;
    border-radius: 20px;
    background-color: #F3F2F0;
} */

/* .InviteStyles .FacebookContacts span {
    color: #3E90E1;
    margin-left: 20px;
} */

.InviteStyles .multipleEmail {
    background-color: #d4d5d6;
    display: inline-block;
    font-size: 14px;
    border-radius: 30px;
    height: 30px;
    padding: 0 4px 0 1rem;
    display: inline-flex;
    align-items: center;
    margin: 0.6rem 0.3rem 0.3rem 0.6rem;
}

.InviteStyles .multipleEmail>.button {
    background-color: white;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    font: inherit;
    margin-left: 10px;
    font-weight: bold;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.InviteOptionsContainer_align {
  display: flex;
  justify-content: space-between;
}.GmailContacts_align {
    /* margin-left: 60px; */
    width: 250px;
    height: 33px;
    border: none;
    border-radius: 20px;
    margin: auto;
    background-color: #f3f2f0;
  }
  .GmailContacts_align span {
    color: #3e90e1;
    font-weight: bold;
  }
  
  .FacebookContacts_align {
    /* margin-left: 30px; */
    width: 250px;
    height: 33px;
    border: none;
    margin: auto;
    border-radius: 20px;
    background-color: #f3f2f0;
  }
  .FacebookContacts_align span {
    color: #3e90e1;
    margin-left: 5px;
    font-weight: bold;
  }`, "",{"version":3,"sources":["webpack://./src/Assets/css/Moderator/InviteMembers.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB;;;0BAGsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,UAAU;;IAEV,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;AACA;IACI;AACJ;AACA;IACI,iBAAiB;AACrB;;AAEA;;;;;;;GAOG;;AAEH;;;GAGG;;AAEH;;;;;;;GAOG;;AAEH;;;GAGG;;AAEH;IACI,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC,CAAC;IACG,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB","sourcesContent":[".InviteStyles .modal-content {\r\n    /* border-radius: 30px; */\r\n    /* width:700px;\r\n    min-height: 593px;\r\n    padding-left: 20px;\r\n    padding-right: 20px; */\r\n    background-color: #fff !important;\r\n}\r\n\r\n.background-for-whole {\r\n    border-radius: 30px;\r\n    width: 90%;\r\n\r\n    margin: 20px auto;\r\n    padding: 20px;\r\n    min-height: 400px;\r\n    background-color: #fff  !important;\r\n}\r\n\r\n.InviteStyles .title {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n}\r\n\r\n.InviteStyles .InvitationEmail {\r\n    /* border:1px solid red; */\r\n    width: 95%;\r\n    margin: auto;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.InviteStyles .InvitationEmail input {\r\n    width: 100%;\r\n    border-radius: 50px;\r\n    border: 2px solid grey;\r\n    font-size: 16px;\r\n    padding: 11px;\r\n}\r\n\r\n.InviteStyles .InvitationSubject {\r\n    width: 95%;\r\n    margin: auto;\r\n    margin-bottom: 20px;\r\n\r\n}\r\n\r\n.InviteStyles .InvitationSubject input {\r\n    width: 100%;\r\n    border-radius: 50px;\r\n    border: 2px solid grey;\r\n    font-size: 16px;\r\n    padding: 11px;\r\n}\r\n\r\n.InviteStyles .InvitationTextaera {\r\n    /* border:1px solid red; */\r\n    width: 95%;\r\n    margin: auto;\r\n    margin-bottom: 20px;\r\n    \r\n}\r\n\r\n.InviteStyles .InvitationTextaera textarea {\r\n    width: 100%;\r\n    border-radius: 20px;\r\n    border: 2px solid grey;\r\n    font-size: 16px;\r\n    padding: 11px;\r\n}\r\n\r\n.InviteStyles .Invite {\r\n    width: 88px;\r\n    height: 33px;\r\n    border: none;\r\n    border-radius: 20px;\r\n    background-color: rgb(7, 55, 100);\r\n    color: white;\r\n    margin-left: 270px;\r\n    cursor: pointer;\r\n}\r\n\r\n.InviteStyles .Invite:disabled {\r\n    width: 88px;\r\n    height: 33px;\r\n    border: none;\r\n    border-radius: 20px;\r\n    background-color: #98B9D8;\r\n    color: white;\r\n    margin-left: 270px;\r\n    cursor: pointer;\r\n}\r\n\r\n.InviteStyles .Change {\r\n    position: relative;\r\n    padding: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.InviteStyles .Change::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 22px;\r\n    left: 8px;\r\n    border: 1px solid;\r\n    width: 290px;\r\n    height: 2px;\r\n}\r\n\r\n.InviteStyles .Change::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 22px;\r\n    right: 8px;\r\n    border: 1px solid;\r\n    width: 290px;\r\n    height: 2px;\r\n}\r\n\r\n.or-container{\r\n    display: flex;\r\n}\r\n.or-container hr{\r\n    flex:1\r\n}\r\n.or-container p{\r\n    padding: 8px 16px;\r\n}\r\n\r\n/* .InviteStyles .GmailContacts {\r\n    margin-left: 60px;\r\n    width: 250px;\r\n    height: 33px;\r\n    border: none;\r\n    border-radius: 20px;\r\n    background-color: #F3F2F0;\r\n} */\r\n\r\n/* .InviteStyles .GmailContacts span {\r\n    color: #3E90E1;\r\n    margin-left: 20px;\r\n} */\r\n\r\n/* .InviteStyles .FacebookContacts {\r\n    margin-left: 30px;\r\n    width: 250px;\r\n    height: 33px;\r\n    border: none;\r\n    border-radius: 20px;\r\n    background-color: #F3F2F0;\r\n} */\r\n\r\n/* .InviteStyles .FacebookContacts span {\r\n    color: #3E90E1;\r\n    margin-left: 20px;\r\n} */\r\n\r\n.InviteStyles .multipleEmail {\r\n    background-color: #d4d5d6;\r\n    display: inline-block;\r\n    font-size: 14px;\r\n    border-radius: 30px;\r\n    height: 30px;\r\n    padding: 0 4px 0 1rem;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    margin: 0.6rem 0.3rem 0.3rem 0.6rem;\r\n}\r\n\r\n.InviteStyles .multipleEmail>.button {\r\n    background-color: white;\r\n    width: 22px;\r\n    height: 22px;\r\n    border-radius: 50%;\r\n    border: none;\r\n    cursor: pointer;\r\n    font: inherit;\r\n    margin-left: 10px;\r\n    font-weight: bold;\r\n    padding: 0;\r\n    line-height: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.InviteOptionsContainer_align {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}.GmailContacts_align {\r\n    /* margin-left: 60px; */\r\n    width: 250px;\r\n    height: 33px;\r\n    border: none;\r\n    border-radius: 20px;\r\n    margin: auto;\r\n    background-color: #f3f2f0;\r\n  }\r\n  .GmailContacts_align span {\r\n    color: #3e90e1;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .FacebookContacts_align {\r\n    /* margin-left: 30px; */\r\n    width: 250px;\r\n    height: 33px;\r\n    border: none;\r\n    margin: auto;\r\n    border-radius: 20px;\r\n    background-color: #f3f2f0;\r\n  }\r\n  .FacebookContacts_align span {\r\n    color: #3e90e1;\r\n    margin-left: 5px;\r\n    font-weight: bold;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
